<form [formGroup]="form" appFormErrorScroll>
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field>
        <mat-label>Current loan balance (from TaxTank)</mat-label>
        <input matInput type="number" formControlName="currentLoanBalance">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6">
      <mat-form-field>
        <mat-label>What was the loan payout amount?</mat-label>
        <input matInput type="number" formControlName="payoutAmount" placeholder="Loan payout amount" required>
        @if (form.get('payoutAmount').invalid) {
          <mat-error>
            <app-validation-error [errors]="form.get('payoutAmount').errors"></app-validation-error>
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6">
      <app-datepicker label="Loan termination date" formControlName="date"></app-datepicker>
    </div>

    <div class="col-12 col-md-6">
      <mat-form-field>
        <mat-label>Bank fees and charges</mat-label>
        <input matInput type="number" formControlName="fees" placeholder="Bank fees and charges" required>
        @if (form.get('fees').invalid) {
          <mat-error>
            <app-validation-error [errors]="form.get('fees').errors"></app-validation-error>
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</form>
